/**
 * WVB-02 — Financial KPI Card component
 * Used in both EventFinancialsWorkspace overview and EventMasterWorkspace panel.
 */
import { Lock } from "lucide-react";
import { AVAIL_CONFIG } from "./EventFinancialsUtils";

export default function FinKpiCard({ kpi, compact = false }) {
  if (!kpi) return null;
  const avail = AVAIL_CONFIG[kpi.availability] || AVAIL_CONFIG.NOT_YET_AVAILABLE;
  const isAvail = kpi.availability === "AVAILABLE";

  if (compact) {
    return (
      <div className="bg-white border border-slate-200 rounded-xl p-4">
        <div className="text-xs text-slate-400 font-medium mb-1">{kpi.label}</div>
        <div className={`text-lg font-bold ${isAvail ? "text-slate-800" : "text-slate-400"}`}>
          {kpi.value_display}
        </div>
        {!isAvail && (
          <div className="flex items-center gap-1 mt-1">
            <Lock className="w-3 h-3 text-slate-300" />
            <span className="text-xs text-slate-400">{avail.label}</span>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 flex flex-col gap-2">
      <div className="flex items-start justify-between gap-2">
        <span className="text-sm text-slate-500 font-medium leading-tight">{kpi.label}</span>
        <span className={`text-xs px-2 py-0.5 rounded-full border font-medium flex-shrink-0 ${avail.cls}`}>
          {avail.label}
        </span>
      </div>
      <div className={`text-2xl font-bold ${isAvail ? "text-slate-800" : "text-slate-300"}`}>
        {isAvail ? kpi.value_display : "—"}
      </div>
      {!isAvail && (
        <div className="flex items-center gap-1.5 text-xs text-slate-400">
          <Lock className="w-3 h-3" />
          {kpi.value_display}
        </div>
      )}
      {kpi.note && (
        <div className="text-xs text-slate-400 leading-tight">{kpi.note}</div>
      )}
    </div>
  );
}
